/* tslint:disable */
/* eslint-disable */
/**
 * Localingos API
 * Developer-first automated localization platform powered by AI. Sync your project and continuously localize only what changed.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BatchTranslationRequest } from '../models';
// @ts-ignore
import type { PostTranslationsRequest } from '../models';
// @ts-ignore
import type { TranslationDto } from '../models';
/**
 * TranslationControllerApi - axios parameter creator
 * @export
 */
export const TranslationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} projectId 
         * @param {BatchTranslationRequest} batchTranslationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranslationsBatch: async (projectId: string, batchTranslationRequest: BatchTranslationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getTranslationsBatch', 'projectId', projectId)
            // verify required parameter 'batchTranslationRequest' is not null or undefined
            assertParamExists('getTranslationsBatch', 'batchTranslationRequest', batchTranslationRequest)
            const localVarPath = `/translation/{projectId}/batch`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchTranslationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectId 
         * @param {string} foreignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranslationsByForeignId: async (projectId: string, foreignId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getTranslationsByForeignId', 'projectId', projectId)
            // verify required parameter 'foreignId' is not null or undefined
            assertParamExists('getTranslationsByForeignId', 'foreignId', foreignId)
            const localVarPath = `/translation/{projectId}/{foreignId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"foreignId"}}`, encodeURIComponent(String(foreignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranslationsByProjectId: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getTranslationsByProjectId', 'projectId', projectId)
            const localVarPath = `/translation/{projectId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostTranslationsRequest} postTranslationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTranslations: async (postTranslationsRequest: PostTranslationsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postTranslationsRequest' is not null or undefined
            assertParamExists('postTranslations', 'postTranslationsRequest', postTranslationsRequest)
            const localVarPath = `/translation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postTranslationsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TranslationControllerApi - functional programming interface
 * @export
 */
export const TranslationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TranslationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} projectId 
         * @param {BatchTranslationRequest} batchTranslationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTranslationsBatch(projectId: string, batchTranslationRequest: BatchTranslationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TranslationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTranslationsBatch(projectId, batchTranslationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranslationControllerApi.getTranslationsBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectId 
         * @param {string} foreignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTranslationsByForeignId(projectId: string, foreignId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TranslationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTranslationsByForeignId(projectId, foreignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranslationControllerApi.getTranslationsByForeignId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTranslationsByProjectId(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TranslationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTranslationsByProjectId(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranslationControllerApi.getTranslationsByProjectId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PostTranslationsRequest} postTranslationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postTranslations(postTranslationsRequest: PostTranslationsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postTranslations(postTranslationsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranslationControllerApi.postTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TranslationControllerApi - factory interface
 * @export
 */
export const TranslationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TranslationControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} projectId 
         * @param {BatchTranslationRequest} batchTranslationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranslationsBatch(projectId: string, batchTranslationRequest: BatchTranslationRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TranslationDto>> {
            return localVarFp.getTranslationsBatch(projectId, batchTranslationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectId 
         * @param {string} foreignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranslationsByForeignId(projectId: string, foreignId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TranslationDto>> {
            return localVarFp.getTranslationsByForeignId(projectId, foreignId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranslationsByProjectId(projectId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TranslationDto>> {
            return localVarFp.getTranslationsByProjectId(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PostTranslationsRequest} postTranslationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTranslations(postTranslationsRequest: PostTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postTranslations(postTranslationsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TranslationControllerApi - object-oriented interface
 * @export
 * @class TranslationControllerApi
 * @extends {BaseAPI}
 */
export class TranslationControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} projectId 
     * @param {BatchTranslationRequest} batchTranslationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranslationControllerApi
     */
    public getTranslationsBatch(projectId: string, batchTranslationRequest: BatchTranslationRequest, options?: RawAxiosRequestConfig) {
        return TranslationControllerApiFp(this.configuration).getTranslationsBatch(projectId, batchTranslationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectId 
     * @param {string} foreignId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranslationControllerApi
     */
    public getTranslationsByForeignId(projectId: string, foreignId: string, options?: RawAxiosRequestConfig) {
        return TranslationControllerApiFp(this.configuration).getTranslationsByForeignId(projectId, foreignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranslationControllerApi
     */
    public getTranslationsByProjectId(projectId: string, options?: RawAxiosRequestConfig) {
        return TranslationControllerApiFp(this.configuration).getTranslationsByProjectId(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PostTranslationsRequest} postTranslationsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TranslationControllerApi
     */
    public postTranslations(postTranslationsRequest: PostTranslationsRequest, options?: RawAxiosRequestConfig) {
        return TranslationControllerApiFp(this.configuration).postTranslations(postTranslationsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

